type FbCapitolUpgradedData = {
    level: number;
};

export class FbCapitolUpgradedHandler {
    public handle(data: FbCapitolUpgradedData): void {
        if (typeof window.app.fb_capitol_upgraded === 'function') {
            window.app.fb_capitol_upgraded(data.level);
        } else {
            console.warn('No fb_capitol_upgraded handler, skipping');
        }
    }
}
